import React, {useMemo, useState} from 'react'
import {useAuth} from "../../../providers/AuthProvider";
import Form from "../../../components/form/Form";
import FlipMove from "react-flip-move";
import NEWSkillFormButton from "../../profiles/components/NEWSkillFormButton";

const SupplierIndustriesStep = React.forwardRef(({ supplierOrg, isDisabled, onChange, isFormSubmitted,...props }, formRef) => {

    const { auth } = useAuth();

    const [editingIndex, setEditingIndex] = useState(false);

    let supplierFormClass = "talent-role-form";
    if (isDisabled) {
        supplierFormClass += ' pointer-events-none opacity-80';
    }
    const selectIndustry = async (industry) => {

        let industries_worked = [...(supplierOrg.industries_worked || [])];


        if (TB.isDefined(industry.self_score)) {
            if (TB.find(industries_worked, ['id', parseInt(industry.id)])) {
                industries_worked = TB.map(industries_worked, model => {
                    if (model.id === parseInt(industry.id)) {
                        return { ...industry };
                    }
                    return model;
                });
            } else {
                industries_worked.push(industry);
            }

        } else {
            industries_worked = TB.xorBy(industries_worked, [industry], 'id');
        }

        return onChange({ industries_worked })
    }

    const allIndustries = useMemo(() => {
        let industries = TB.map(laravel.client_industries, (name, id) => ({ name, id: parseInt(id) }));

        let selectedIds = TB.map(supplierOrg?.industries_worked || [], 'id')
        return TB.orderBy(industries, [
            industry => selectedIds.includes(industry.id) ? selectedIds.indexOf(industry.id) : 1000,
            industry => selectedIds.includes(industry.id),
        ], ['asc', 'asc'])
    }, [supplierOrg?.industries_worked])
    return (
        <div>
            <div className="form-title-section">
                <div className="step-title-content">
                    <div>
                        <div className="flex items-center pb-4">
                            <h3 className="form-title !mb-0">
                                Agency Industry Experience
                            </h3>

                        </div>

                        <h5 className="form-subtitle">
                            Highlight industries and years of experience worked with.
                        </h5>
                    </div>
                </div>
            </div>

            <div className={supplierFormClass}>
                <Form
                    ref={formRef}
                    title={false}
                    subtitle={null}
                    showRequired
                    submitButton={false}
                    onChange={(model) => {
                        let updates = { ...model }
                        for (let [key, value] of Object.entries(model)) {
                            updates = TB.set(updates, key, value)
                        }
                        onChange(updates)
                    }}
                    model={supplierOrg}
                    fields={[]}
                    isDisabled={isDisabled}>


                    <div className="discipline-skills-container skill-importance-container py-4 relative gap-3">
                        <FlipMove typeName={null} maintainContainerHeight={true}>
                            {TB.map(allIndustries, (industry, index) => {
                                const match = TB.find(supplierOrg?.industries_worked || [], ['id', industry.id])

                                return (
                                    <div key={industry.id}>
                                        <NEWSkillFormButton
                                            valuePropName={'self_score'}
                                            disabled={isDisabled}
                                            scoringOptions={laravel.talent_scoring_options}
                                            skill={match || industry}
                                            onChange={selectIndustry}
                                            className="min-w-[115px]"
                                        />
                                    </div>
                                )
                            })}
                        </FlipMove>
                    </div>
                </Form>
            </div>
        </div>
    )
})
export default SupplierIndustriesStep

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};